export const GET_DIMENSIONS_OUTCOMES_WATCHER =
  "app/WidgetListOutcomes/GET_DIMENSIONS_OUTCOMES_WATCHER"
export const GET_DIMENSIONS_OUTCOMES_SUCCESS =
  "app/WidgetListOutcomes/GET_DIMENSIONS_OUTCOMES_SUCCESS"
export const GET_DIMENSIONS_OUTCOMES_FAILED =
  "app/WidgetListOutcomes/GET_DIMENSIONS_OUTCOMES_FAILED"
